import React, { useState }from "react";
import { Link, useNavigate } from 'react-router-dom'

const Sidebar = ({ user, renderCurrentNotification,}) => {

    const [isVisible, setIsVisible] = useState(false)

    return(
                    <div className="overpopsups" style={{display: "flex", flexDirection: 'row-reverse', left: "0px", right: 'auto', transform: isVisible ? 'translateX(0%)' : 'translateX(-91%)', transition: "transform 0.5s ease"}}>
                        <div className="overpopsups-icon" onClick={() => {setIsVisible(!isVisible)}} style={{transform: isVisible  && 'rotate(180deg)', left: '10px'}}></div>
                        <div className="overpopsups-data" style={{ display: 'block'}}>
                            <div className="overpopsups-profile">
                                <div className="overpopsups-profile-l"><img src="/img/account_circle_head.svg" /></div>
                                <div className="overpopsups-profile-r">{user.name}</div>
                            </div>
                            <div className="menunospace">
                                <Link className="menupops" to="/myrisk">Notifications
                                    <div className="overpopsups-profile-r">
                                        <div className="notylk2">
                                            {renderCurrentNotification()}
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            <div className="menunospace">
                                <Link className="menupops" to="/">Home/News Feed</Link>
                                <Link className="menupops" to="">Connections</Link>
                                <Link className="menupops" to="">Email</Link>
                                <Link className="menupops" to="/lk/">Settings</Link>
                            </div>
                            <Link className="menupops" to="/risk/">Create & Register H&R Assessment</Link>
                            <Link className="menupops" to="/myrisk/">Review H&R Assessment</Link>
                            <Link className="menupops" to="/dashboard/">Dashboard</Link>
                        </div>
                    </div>
    )
}

export default Sidebar;